import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { FaHome, FaInfoCircle, FaList, FaChartBar } from "react-icons/fa";
import { GrMenu } from "react-icons/gr";
import { useI18n } from "@/components/languages";
import { LanguageSelect } from "@/components/ui/language";
import { Button } from "@/components/ui/button";
import { Share } from "./share";

import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

export function Navbar() {
  const location = useLocation();
  const { t } = useI18n();

  const links = [
    { label: t("navbar.home"), path: "/", icon: <FaHome /> },
    { label: t("navbar.about"), path: "/about", icon: <FaInfoCircle /> },
    { label: t("navbar.list"), path: "/list", icon: <FaList /> },
    { label: t("navbar.stats"), path: "/stats", icon: <FaChartBar /> },
  ];

  return (
    <nav className="border-b px-4 py-2 shadow-sm bg-background relative">
      <div className="max-w-[1100px] mx-auto relative flex items-center h-12">
        {/* Left: Menu button */}
        <div className="flex items-center">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="secondary" size="icon" aria-label="Open menu">
                <GrMenu />
              </Button>
            </SheetTrigger>

            <SheetContent side="left" className="w-64 pt-6">
              <SheetHeader>
                <SheetTitle className="text-left text-lg">Menu</SheetTitle>
              </SheetHeader>

              <ul className="flex flex-col space-y-2 mt-6">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className={cn(
                        "flex items-center space-x-2 p-4 rounded-md hover:bg-muted/10 text-lg transition-colors",
                        location.pathname === link.path
                          ? "text-foreground font-medium"
                          : "text-muted-foreground",
                      )}
                    >
                      {link.icon}

                      <span className="pl-4">{link.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </SheetContent>
          </Sheet>
        </div>

        {/* Center: Logo */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <Link
            to="/about"
            className="flex items-center gap-3 text-lg font-bold text-foreground px-4 py-2 rounded-md hover:bg-muted/10"
          >
            <img
              src="/assets/images/32.png"
              alt=""
              className="h-8 w-auto rounded-md border object-contain"
            />

            <span>Is It Cinematic?</span>
          </Link>
        </div>

        {/* Right: Language + Share */}
        <div className="ml-auto flex items-center gap-2">
          <LanguageSelect />
          <Share />
        </div>
      </div>
    </nav>
  );
}
